export { default } from "./SetUpTwoFactor";
